//Core modules
import React, {Fragment} from 'react';

//Internal modules
import Common from "../../Common/Common"
import PlansContent from './PlansContent';

const Plans = () => {

    return (
        <>
            <Common 
                pageTitle={"Plans"} 
                customClass="no-padding" 
                mainContent={
                    <PlansContent/>
                }
            />
        </>
    )
}

export default Plans;